export const ROUTER_PATHS = {
  login: '/',
  screening: '/screening'
}
